import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const AdminDeleteEventSlice = createSlice({
  name: 'AdminDeleteEvent',
  initialState,
  reducers: {
    Admin_Delete_Event_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Admin_Delete_Event_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Admin_Delete_Event_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Admin_Delete_Event_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Admin_Delete_Event_request, Admin_Delete_Event_success, Admin_Delete_Event_failure, Clear_Admin_Delete_Event_Check } = AdminDeleteEventSlice.actions

export default AdminDeleteEventSlice.reducer